// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("resources/images/TinyTacoTalking.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IsyhTAgs2QoOFs {
  margin-top: 24px;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  letter-spacing: -0.006em;
  line-height: 20px;
  font-weight: 600;
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  text-shadow: 0 1px 1px var(--ds-shadow-overflow-spread, #091e4229);
}
.iWM0tpkpMANDyE {
  width: 66px;
  height: 82px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `IsyhTAgs2QoOFs`,
	"tacoImage": `iWM0tpkpMANDyE`
};
export default ___CSS_LOADER_EXPORT___;
